export const phoneDisplayValueCasting = (value: string) =>
  // eslint-disable-next-line
  value.replace(/(.{2})(\d{3})(\d{3})(\d{2})(\d{2})/g, `$1 ($2) $3-$4-$5`);
